var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlame24 = function SvgFlame24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4.278c0-1.357 1.534-2.126 2.623-1.347 3.302 2.358 4.161 6.819 2.158 10.187a4.5 4.5 0 0 0 1.567-1.442c.796-1.195 2.65-.758 2.828.667l.153 1.226c.443 3.548-1.79 6.889-5.22 7.868A7.14 7.14 0 0 1 5 14.574v-.658a6.15 6.15 0 0 1 2.987-5.274A4.15 4.15 0 0 0 10 5.085v-.807Zm2 .716v.09a6.15 6.15 0 0 1-2.986 5.274A4.15 4.15 0 0 0 7 13.915v.66a5.14 5.14 0 0 0 6.56 4.94c2.49-.712 4.104-3.138 3.784-5.699l-.02-.167a6.502 6.502 0 0 1-3.145 1.837l-1.937.484a1 1 0 0 1-1.001-1.62l1.247-1.456c2.017-2.354 1.746-5.858-.488-7.9Z",
    fill: "currentColor"
  })));
};
export default SvgFlame24;